export default __webpack_public_path__ + "static/media/misc-drawerB-1440w.3a49d3f6.webp";